import SiteHeader from './components/SiteHeader';
import Hero from './components/Hero';
import LiveTimeline from './components/LiveTimeline';
import FirstRelease from './components/FirstRelease';
import DiscussionZone from './components/DiscussionZone';
import PhotoGrid from './components/PhotoGrid';
import Topics from './components/Topics';
import SubscribeCta from './components/SubscribeCta';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="home-page min-h-screen bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main>
        <Hero />
        <LiveTimeline />
        <FirstRelease />
        <DiscussionZone />
        <PhotoGrid />
        <Topics />
        <SubscribeCta />
      </main>
      <SiteFooter />
    </div>
  );
}